// one-to-one mapping of errand type to legacy action
export enum ErrandType {
  flyToChapter = 'flyToChapter',
  flyToObject = 'flyToObject',
  flyToCamera = 'flyToCamera',
}
